import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/appointment.css"
import PackageIcon from '../images/package_infor.png'
import JUSTAWASH from '../images/justawash.png'
import SPIFFY from '../images/spiffy.png'
import SPIFFYSHINE from '../images/spiffyshine.png'
import AWESOME from '../images/awesome.png'
import TOTALLYAWESOME from '../images/totallyawesome.png'
import Modal from 'react-modal';
import AppointmentService from '../utils/AppointmentService.js';
import CloseIcon from 'react-icons/lib/fa/close';
//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export class Package extends Component {
  constructor(props) {
    super(props)
    this.state ={
      openPackage: false,
      width: document.body.clientWidth,
    }
    this.ApptService = new AppointmentService()
    this.updateDimensions = this.updateDimensions.bind(this)
  }
  componentDidMount(props){
    window.addEventListener("resize", this.updateDimensions);
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  showInfo = (event) => {
    event.cancelBubble = true;
    this.openModal()
    if(event.stopPropagation)
      event.stopPropagation();
    }
    updateDimensions() {
        this.setState({width: document.body.clientWidth});
    }
    openModal() {
      this.setState({
        openPackage: true
      })
    }
    closeWindow = (event) => {
      event.cancelBubble = true;
      if(event.stopPropagation)
        event.stopPropagation();
      this.setState({
        openPackage: false
      })
    }

  render() {
    var vehiclePackage = this.props.vehiclePackage
    var packageAmount = 0
    if(vehiclePackage){
      var packageAmount = vehiclePackage.amount/100
      var packageAfterDiscount = vehiclePackage.amount_after_promo/100
    }
    var style = {}
    if(this.props.selectedPackage && this.props.vehiclePackage && this.props.vehiclePackage.id == this.props.selectedPackage.id){
      style = {
            backgroundColor:'#ff8c00'
      }
    }
    const customStyles =
      this.state.width < 780 ?
      {
        content : {
          top                   : 'auto',
          left                  : '0%',
          height                : 'auto',
          width                 : 'auto',
          padding               : '0px',
          right                 : 'auto',
        }
      }:
        {
          content : {
            top                   : 'auto',
            left                  : '32%',
            height                : 'auto',
            width                 : 'auto',
            padding               : '0px',
            right                 : 'auto',
          }
    }
    return (
      <div onClick={() => this.props.showUpgrades(vehiclePackage)} className="package-header card-header" role="tab" id={'package' + vehiclePackage.id} style = {style}>
        <h5 className="mb-0">
          <a><img onClick={(e) => this.showInfo(e)} className="packageInfoImage" src={PackageIcon}></img></a>
          <a href="#collapse1" className="packageTitle" data-parent="#accordion" data-toggle="collapse">{this.props.vehiclePackage.display_title}
            {
              packageAfterDiscount != packageAmount &&
              <div className="float-right">
                <span className="original-price float-right"><strike>${packageAmount}</strike></span><br></br>
                <span className="discountPrice float-right">${packageAfterDiscount}</span>
              </div>
            }
            {
              !(packageAfterDiscount != packageAmount) &&
              <div className="float-right">
                <span className="discountPrice float-right">${packageAmount}</span>
              </div>
            }
          </a>
          <div className="displayBlurbContainer">
            <p className="displayBlurb"  dangerouslySetInnerHTML={{ __html:this.props.vehiclePackage.display_short_blurb}}></p>
          </div>
        </h5>
        {(this.props.vehiclePackage && this.props.vehiclePackage.promotional_image_url) &&
          <img className="promotionalImage" src={this.props.vehiclePackage.promotional_image_url}></img>
        }
          <Modal
            isOpen={this.state.openPackage}
            style={customStyles}
          >
          <CloseIcon className='closeButton' onClick={(e) => this.closeWindow(e)} />
            <span dangerouslySetInnerHTML={{__html: vehiclePackage.display_blurb_html}} />
          </Modal>
      </div>
    )
  }
}
export default Package



// WEBPACK FOOTER //
// ./src/Components/Package.js